import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchPurchases,
  createPurchase,
  updatePurchase,
  deletePurchase,
  patchPurchase,
} from "./thunks";
import { Purchase } from "@/types";
import { toast } from "react-toastify";

interface PaginatedPurchases {
  data: Purchase[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface PurchasesState {
  purchases: PaginatedPurchases;
  loading: boolean;
  error: string | null;
}

const initialState: PurchasesState = {
  purchases: { data: [] },
  loading: false,
  error: null,
};

const PurchaseSlice = createSlice({
  name: "purchases",
  initialState,
  reducers: {
    clearSuppliers: (state) => {
      state.purchases = { data: [] };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchPurchases.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchPurchases.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          const payload = action.payload;

          if (Array.isArray(payload.data)) {
            // Dados não paginados
            state.purchases = { data: payload.data };
          } else {
            // Dados paginados
            state.purchases = {
              data: payload.data.data,
              total: payload.data.total,
              currentPage: payload.data.current_page,
              perPage: payload.data.per_page,
            };
          }
        },
      )
      .addCase(fetchPurchases.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })
      // Create
      .addCase(createPurchase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createPurchase.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          //state.purchases.data.push(action.payload.data);
          toast.success("Compra cadastrada com sucesso!");
        },
      )
      .addCase(createPurchase.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Não foi possível cadastrar a compra, tente novamente!");
      })

      // Update
      .addCase(updatePurchase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        updatePurchase.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          const index = state.purchases.data.findIndex(
            (s) => s.id == action.payload.data.id,
          );
          if (index !== -1) {
            state.purchases.data[index] = action.payload.data;
          }
          toast.success("Compra atualizada com sucesso!");
        },
      )
      .addCase(updatePurchase.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // Delete
      .addCase(deletePurchase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        deletePurchase.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.purchases.data = state.purchases.data.filter(
            (s) => String(s.id) != action.payload.data.id,
          );
          toast.success("Compra excluída com sucesso!");
        },
      )
      .addCase(deletePurchase.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })

      // Patch
      .addCase(patchPurchase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(patchPurchase.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.purchases.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          // Merge dos dados antigos com os novos
          state.purchases.data[index] = {
            ...state.purchases.data[index],
            ...action.payload.data,
          };
        }
        toast.success("Baixa de compra realizada com sucesso!");
      })
      .addCase(patchPurchase.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      });
  },
});

export default PurchaseSlice.reducer;
